import _ from 'lodash';
import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles/index';

const styles = () => {
	return {
		product: {
			paddingLeft: 10,
			fontSize: 14,
			color: "#666",
		},
		loading: {
			fontSize: 11,
			lineHeight: '11px',
			color: '#777'
		},
		margin: {
			margin: '5px 0px',
		}
	};
};

class FMPTerminalSupplierSelect extends PureComponent {
	constructor (props) {
		super(props);
		this.state = {
			terminalId : '',
			supplierId : '',
			supplierOptions : [],
		};
	}

	// noinspection JSUnusedGlobalSymbols
	static getDerivedStateFromProps(nextProps, prevState) {
		const {
			terminals, supplierMap, productTypes, justBulk,
			onChange, path } = nextProps;
		const { terminalId, supplierId } = nextProps;
		let newState = {};
		if (
			terminalId === prevState.terminalId &&
			supplierId === prevState.supplierId
		) {
			return newState;
		}

		if (!terminalId) { return newState; }

		newState = {
			terminalId,
			supplierId : '',
		};
		const terminal = _.find(terminals, { terminalId });
		if (!terminal) {
			console.error('Missing terminal', terminals, terminalId);
			return;
		}

		newState.supplierOptions = getSupplierOptions({
			terminal,
			supplierMap,
			productTypes,
			justBulk,
		});
		if (supplierId) {
			newState.supplierId = supplierId;
		}

		onChange(newState, path);
		return newState;
	}

	onSupplierChange = (event) => {
		const supplierId = event.target.value;
		this.callOnChange({ supplierId });
	};

	onTerminalChange = (event) => {
		const terminalId = event.target.value;
		const { terminals, supplierMap, productTypes, justBulk } = this.props;
		const terminal = _.find(terminals, { terminalId });
		const supplierOptions = getSupplierOptions({
			terminal,
			supplierMap,
			productTypes,
			justBulk,
		});

		const newState = {
			terminalId,
			supplierOptions,
			supplierId : '',
		};
		this.callOnChange(newState);
	};

	callOnChange = (newState) => {
		const { path, onChange } = this.props;
		onChange(newState, path);
		this.setState(newState);
	};

	render () {
		const {
			error, label, terminals, productTypes, md,
			supplierLabel, supplierError, classes,
			justBulk
		} = this.props;

		const {
			terminalId,
			supplierId,
			supplierOptions
		} = this.state;

		const disabled = (!supplierOptions || !supplierOptions.length);

		const supplierAttribute = (justBulk) ? 'bulkSuppliers' : 'supplierProducts';
		const productTypeMap = _.keyBy(productTypes);
		let terminalsWithProduct = _.filter(terminals, terminal => {
			if (!terminal[supplierAttribute]) { return false; }
			return _.some(terminal[supplierAttribute], sp => {
				return productTypeMap[sp.product];
			});
		});

		terminalsWithProduct = _.sortBy(terminalsWithProduct, 'name');
		return (<Fragment>
			<Grid container spacing={2}>
				<Grid item xs={12} md={md} className={classes.margin}>
					<FormControl fullWidth={true} error={!!error}>
						<InputLabel>{label}</InputLabel>
						<Select
							value={terminalId}
							onChange={this.onTerminalChange}
							input={<Input/>}
						>
							{terminalsWithProduct.map(terminal => {
								const { terminalId, name} = terminal;
								return (
									<MenuItem key={terminalId} value={terminalId}>
										{name}
									</MenuItem>
								);
							})}
						</Select>
						{error && <FormHelperText>{error}</FormHelperText>}
					</FormControl>
				</Grid>
			</Grid>

			<Grid container spacing={2}>
				<Grid item xs={12} md={md}  className={classes.margin}>
					{this.renderSupplierOptions({
						supplierOptions,
						label : supplierLabel || 'Supplier',
						error : supplierError,
						supplierId,
						disabled})
					}
				</Grid>
			</Grid>
		</Fragment>
		);
	}

	renderSupplierOptions = ({ supplierOptions, supplierId, disabled, error, label}) => {
		const classes = this.props.classes;

		const hasError = !!error;
		return (
			<FormControl fullWidth={true} disabled={disabled} error={hasError}>
				<InputLabel>{label}</InputLabel>
				<Select
					value={supplierId}
					onChange={this.onSupplierChange}
					input={<Input/>}
				>
					{supplierOptions.map((option, i) => {
						const { supplierId, name, product } = option;
						return (
							<MenuItem key={`${supplierId}_${product}_${i}}`} value={supplierId}>
								<span>{name}</span>
								<span className={classes.product}>{product}</span>
							</MenuItem>
						);
					})}
				</Select>
				{hasError && <FormHelperText>{error}</FormHelperText>}
			</FormControl>
		);
	}

}

function getSupplierOptions({ terminal, supplierMap, productTypes, justBulk}) {
	const productTypeMap = _.keyBy(productTypes);
	const supplierOptions = [];
	const supplierAttribute = (justBulk) ? 'bulkSuppliers' : 'supplierProducts';

	terminal[supplierAttribute].forEach(sp => {
		const {supplierId, product } = sp;
		const supplier = supplierMap[supplierId];
		sp.name = supplier.name;

		if (!supplier) { return console.warn('Missing supplier', sp); }
		if (!productTypeMap[product]) { return; }
		supplierOptions.push(sp);
	});
	return supplierOptions;
}

FMPTerminalSupplierSelect.propTypes = {
	label : PropTypes.string,
	supplierLabel : PropTypes.string,
	path : PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,

	error: PropTypes.string,
	supplierError : PropTypes.string,

	terminals : PropTypes.array,
	supplierMap : PropTypes.object,
	productTypes : PropTypes.array,

	terminalId : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	supplierId : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	justBulk : PropTypes.bool,
	md : PropTypes.number,
	classes : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
])(FMPTerminalSupplierSelect);

FMPTerminalSupplierSelect.defaultProps = {
	justBulk : false,
	md : 6,
};
